/**
 * @author
 * David Rivera (jherax)
 * https://github.com/jherax
 */

// #{FOR_BROWSER} import './polyfills';
import events from 'handle-events';

import fetch from './utils/fetch';
import dom from './utils/dom';
import objects from './utils/objects';
import arrays from './utils/arrays';
import dates from './utils/dates';
import states from './utils/us-states';
import url from './utils/url';
import fp from './utils/fp';
import maps from './utils/maps-api';
import escapeRegExp from './utils/escapeRegExp';
import formatNumber from './utils/formatNumber';
import isPrivateMode from './utils/is-private-mode';
import experiment from './utils/experiments';
import validators from './utils/validators';
import randomInt from './utils/randomInt';
import randomValue from './utils/randomValue';
import loadScript from './utils/dom/loadScript';
import clone, { merge } from './utils/clone';
import warn from './utils/warnings/warn';
import createElementFromHTML from './utils/dom/createElementFromHTML';
import scrollToNative from './utils/dom/scrollToNative';
import when from './utils/when';
import core from './core/main';

// #{FOR_BROWSER} window.proxyStorage = require('proxy-storage');
// #{FOR_BROWSER} require('./utils/raygun')();

export default Object.assign(
  {
    escapeRegExp,
    formatNumber,
    isPrivateMode,
    experiment,
    validators,
    randomInt,
    randomValue,
    loadScript,
    clone,
    merge,
    warn,
    createElementFromHTML,
    scrollToNative,
    when,
    core,
    // #{FOR_BROWSER} fn: require('./utils/warnings/deprecated')('hc.fn', 'hc.invoke', fp.invoke),
  }, events, fetch, dom, objects, arrays, dates, states, url, fp, maps);
